import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Client } from '../models/client.model';
import { CDCService, IClientSearchParams } from '../services/cdc.service';
import { ErrorService } from '../services/error.service';
import { LoadingService } from '../services/loading.service';
import { SaleService } from '../services/sale.service';
import { Sale } from '../models/sale.model';

@Injectable({
  providedIn: 'root',
})
export class OrderSearchResolver implements Resolve<Sale[]> {
  constructor(
    private _cdcService: CDCService,
    private _router: Router,
    private _errorService: ErrorService,
    private _loadingService: LoadingService,
    private _translateService: TranslateService,
    private _salesHistoryService: SaleService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Sale[]> {
    if(route.queryParams.email || route.queryParams.phone) {
      if(route.queryParams.start && route.queryParams.end){
        this._salesHistoryService.dateRange = new FormGroup({
          start: new FormControl(new Date(route.queryParams.start)),
          end: new FormControl(new Date(route.queryParams.end))
        });
      }else{
        this._salesHistoryService.dateRange = new FormGroup({
          start: new FormControl(new Date(new Date().setDate(new Date().getDate() - 30))),
          end: new FormControl(new Date())
        });
      }
      let timeDifference =  this._salesHistoryService.dateRange.value.end.valueOf() -  this._salesHistoryService.dateRange.value.start.valueOf();

      if(timeDifference > 63113904000){
        this._errorService.showError('clientSearch.dateRangeTooLarge');
        this._router.navigateByUrl('/client-search');
        throw new Error(
          this._translateService.instant('clientSearch.dateRangeTooLarge')
        );
      }
      const searchQuery: IClientSearchParams = { fields: ['data', 'profile'] };
      if(route.queryParams.email) {
        searchQuery.email = route.queryParams.email;
      }
      if(route.queryParams.phone) {
        searchQuery.phoneNumber = route.queryParams.phone;
      }
      return this._cdcService
        .clientSearch(searchQuery).pipe(switchMap((clients: Client[]) => {
          this._salesHistoryService.customerIds = clients.reduce((arr, res) => {
            arr.push(...res.ids);
            return arr;
          }, <string[]>[]);
          if(this._salesHistoryService.customerIds.length > 16) {
            this._errorService.showError('errors.tooMuchIds');
            this._router.navigateByUrl('/client-search');
            throw new Error(
              this._translateService.instant('errors.tooMuchIds')
            );
          }
          this._loadingService.startLoading();
          return this._salesHistoryService
            .getIniitalSaleHistory()
            .pipe(
              switchMap((sales) => {
                this._loadingService.stopLoading();
                if (sales.length > 0) {
                  return of(sales);
                } else {
                  this._errorService.showError('errors.ordersNoOrders');
                  throw new Error(
                    this._translateService.instant('errors.ordersNoOrders')
                  );
                }
              }),
              catchError(() => {
                this._loadingService.stopLoading();
                return of(null);
              })
            );
        }))
    }
    if (this._salesHistoryService.sales.length > 0) {
      return of(this._salesHistoryService.sales);
    } else if (this._salesHistoryService.customerIds.length > 0) {
      if(this._salesHistoryService.customerIds.length > 16) {
        this._errorService.showError('errors.tooMuchIds');
        this._router.navigateByUrl('/client-search');

        throw new Error(
          this._translateService.instant('errors.tooMuchIds')
        );
      }
      if(this._salesHistoryService.dateRange && this._salesHistoryService.dateRange.value.start && this._salesHistoryService.dateRange.value.end) {
        let timeDifference =  this._salesHistoryService.dateRange.value.end.valueOf() -  this._salesHistoryService.dateRange.value.start.valueOf();
        if(timeDifference > 63113904000){
          this._errorService.showError('clientSearch.dateRangeTooLarge');
          this._router.navigateByUrl('/client-search');
          throw new Error(
            this._translateService.instant('clientSearch.dateRangeTooLarge')
          );
        }
      }

      this._loadingService.startLoading();
      return this._salesHistoryService
        .getIniitalSaleHistory()
        .pipe(
          switchMap((sales) => {
            this._loadingService.stopLoading();
            if (sales.length > 0) {
              return of(sales);
            } else {
              this._errorService.showError('errors.ordersNoOrders');
              throw new Error(
                this._translateService.instant('errors.ordersNoOrders')
              );
            }
          }),
          catchError(() => {
            this._loadingService.stopLoading();
            return of(null);
          })
        );
    } else {
      this._errorService.showError('errors.noCustomerId');
      this._router.navigateByUrl('/client-search');
      throw new Error(this._translateService.instant('errors.noCustomerId'));
    }
  }
}
